import { render, staticRenderFns } from "./invites.vue?vue&type=template&id=27085bb6&scoped=true"
import script from "./invites.vue?vue&type=script&lang=js"
export * from "./invites.vue?vue&type=script&lang=js"
import style0 from "./invites.vue?vue&type=style&index=0&id=27085bb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27085bb6",
  null
  
)

export default component.exports